/**
 * SUSANNO Cookie-Consent — GDPR/TTDSG konform
 * Cookiebot-Style: Tabs (Consent / Details / About) + 2 Buttons
 */
(function() {
  'use strict';

  var STORAGE_KEY = 'susanno_cookie_consent';
  var VERSION = '2.0';
  var EXPIRY_DAYS = 180;
  var CATEGORIES = ['analytics', 'marketing', 'preferences'];
  var AUDIT_ENDPOINT = 'https://susanno-consent-log.susannovolturi.workers.dev/log';

  // === Consent Mode v2 DEFAULT ===
  window.dataLayer = window.dataLayer || [];
  function gtag() { dataLayer.push(arguments); }
  gtag('consent', 'default', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied',
    functionality_storage: 'granted',
    personalization_storage: 'denied',
    security_storage: 'granted',
    wait_for_update: 500
  });

  function loadConsent() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var p = JSON.parse(raw);
      if (p.version !== VERSION) return null;
      if (p.expires && p.expires < Date.now()) return null;
      return p;
    } catch (e) { return null; }
  }

  function saveConsent(c) {
    var p = {
      version: VERSION,
      timestamp: Date.now(),
      expires: Date.now() + EXPIRY_DAYS * 86400000,
      analytics: !!c.analytics,
      marketing: !!c.marketing,
      preferences: !!c.preferences
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(p));
    applyConsent(p);
    return p;
  }

  function applyConsent(c) {
    gtag('consent', 'update', {
      ad_storage: c.marketing ? 'granted' : 'denied',
      ad_user_data: c.marketing ? 'granted' : 'denied',
      ad_personalization: c.marketing ? 'granted' : 'denied',
      analytics_storage: c.analytics ? 'granted' : 'denied',
      functionality_storage: c.preferences ? 'granted' : 'denied',
      personalization_storage: c.preferences ? 'granted' : 'denied',
      security_storage: 'granted'
    });

    if (window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.setTrackingConsent) {
      try {
        window.Shopify.customerPrivacy.setTrackingConsent({
          analytics: !!c.analytics,
          marketing: !!c.marketing,
          preferences: !!c.preferences,
          sale_of_data: !!c.marketing
        }, function() {});
      } catch (e) {}
    }

    window.dataLayer.push({
      event: 'cookie_consent_update',
      cookie_consent: { analytics: !!c.analytics, marketing: !!c.marketing, preferences: !!c.preferences }
    });

    try {
      localStorage.setItem('consentMode', JSON.stringify({
        ad_storage: c.marketing ? 'granted' : 'denied',
        analytics_storage: c.analytics ? 'granted' : 'denied'
      }));
    } catch (e) {}

    document.documentElement.setAttribute('data-cookie-consent', 'set');

    // DSGVO-Audit-Log (anonym — IP+UA werden server-seitig gehasht)
    try {
      var loc = (document.documentElement.lang || 'de').split('-')[0];
      fetch(AUDIT_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          analytics: !!c.analytics,
          marketing: !!c.marketing,
          preferences: !!c.preferences,
          lang: loc,
          source: 'banner',
          version: VERSION
        }),
        keepalive: true
      }).catch(function(){});
    } catch (e) {}
  }

  function showBanner() {
    var el = document.getElementById('susanno-cookie-banner');
    if (el) { el.hidden = false; document.body.style.overflow = 'hidden'; }
  }
  function hideBanner() {
    var el = document.getElementById('susanno-cookie-banner');
    if (el) { el.hidden = true; document.body.style.overflow = ''; }
  }

  // Tab-Switching
  function switchTab(target) {
    var banner = document.getElementById('susanno-cookie-banner');
    if (!banner) return;
    banner.querySelectorAll('.susanno-cookie-tab').forEach(function(t) {
      var active = t.dataset.tab === target;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    banner.querySelectorAll('.susanno-cookie-panel').forEach(function(p) {
      var active = p.dataset.panel === target;
      p.classList.toggle('is-active', active);
      p.hidden = !active;
    });
    // Update Button-Label: in "details"-Tab wird "Nein, anpassen" zu "Auswahl speichern"
    var btn = banner.querySelector('[data-cookie-action="toggle-details"] span');
    if (btn) {
      btn.textContent = (target === 'details')
        ? (window.SUSANNO_COOKIE_STRINGS && window.SUSANNO_COOKIE_STRINGS.labelSave) || btn.dataset.stateDetails
        : (window.SUSANNO_COOKIE_STRINGS && window.SUSANNO_COOKIE_STRINGS.labelCustomise) || btn.dataset.stateConsent;
    }
  }

  function getActiveTab() {
    var active = document.querySelector('.susanno-cookie-tab.is-active');
    return active ? active.dataset.tab : 'consent';
  }

  function setTogglesFromConsent(c) {
    CATEGORIES.forEach(function(cat) {
      var input = document.querySelector('[data-cookie-consent="' + cat + '"]');
      if (input) input.checked = c ? !!c[cat] : false;
    });
  }

  function getTogglesValue() {
    var out = {};
    CATEGORIES.forEach(function(cat) {
      var input = document.querySelector('[data-cookie-consent="' + cat + '"]');
      out[cat] = input ? input.checked : false;
    });
    return out;
  }

  function acceptAll() {
    saveConsent({ analytics: true, marketing: true, preferences: true });
    hideBanner();
  }
  function saveSelection() {
    saveConsent(getTogglesValue());
    hideBanner();
  }

  function handleToggleDetailsOrSave() {
    var tab = getActiveTab();
    if (tab === 'details') {
      saveSelection();
    } else {
      switchTab('details');
    }
  }

  function openSettings() {
    var current = loadConsent();
    setTogglesFromConsent(current);
    switchTab('details');
    showBanner();
  }

  // Event Delegation
  document.addEventListener('click', function(e) {
    var tab = e.target.closest('[data-tab]');
    if (tab) {
      e.preventDefault();
      switchTab(tab.dataset.tab);
      return;
    }
    var action = e.target.closest('[data-cookie-action]');
    if (!action) return;
    e.preventDefault();
    switch (action.dataset.cookieAction) {
      case 'accept-all': acceptAll(); break;
      case 'toggle-details': handleToggleDetailsOrSave(); break;
      case 'settings': openSettings(); break;
      case 'close': hideBanner(); break;
    }
  });

  // Footer-Link
  function injectFooterLink() {
    if (!window.SUSANNO_COOKIE_STRINGS) return;
    if (document.querySelector('.susanno-cookie-footer-link')) return;
    // In das Grid (.footer-main--inner) einhängen, nicht in den äußeren
    // Flex-Container (.footer-main) — sonst wird der Button zur eigenen
    // schmalen Flex-Spalte statt einer zentrierten Zeile im Grid.
    var gridParent = document.querySelector('.footer-main--inner');
    var footer = gridParent || document.querySelector('.site-footer, footer.footer, .footer, footer');
    var wrap = document.createElement('div');
    wrap.className = 'susanno-cookie-footer-link-row';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'susanno-cookie-footer-link';
    btn.setAttribute('data-cookie-action', 'settings');
    btn.textContent = window.SUSANNO_COOKIE_STRINGS.footerLink;
    wrap.appendChild(btn);
    if (footer) footer.appendChild(wrap);
    else {
      wrap.style.textAlign = 'center';
      wrap.style.padding = '16px';
      document.body.appendChild(wrap);
    }
  }

  function init() {
    var existing = loadConsent();
    if (existing) {
      applyConsent(existing);
      setTogglesFromConsent(existing);
    } else {
      showBanner();
    }
    injectFooterLink();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
